export type HttpErrorLike = {
  response?: {
    status?: number;
  };
  status?: number;
};

export const resolveStatusFromError = (error: unknown): number | undefined => {
  if (typeof error !== "object" || error === null) {
    return undefined;
  }

  const maybeError = error as HttpErrorLike;

  if (typeof maybeError.response?.status === "number") {
    return maybeError.response.status;
  }

  if (typeof maybeError.status === "number") {
    return maybeError.status;
  }

  return undefined;
};
